import useConfirm from './hooks/useConfirm';
import { Button, Dialog } from '@mui/material';
import { useTheme } from './hooks/useTheme';
import colorConfigs from '../configs/colorConfigs';

const ConfirmPopup = () => {
    const { theme, themeStyles } = useTheme();
    const { confirmPopup, setConfirmPopup, data }: any = useConfirm();
    const closeIconFill = theme === "dark" ? "fill-[#E4E7EC]" : "fill-[#1D2939]";


    const closeModal = () => setConfirmPopup(false);

    const confirmModal = () => {
        data?.isConfirm(() => {
            closeModal();
        });

    }

    return (
        <Dialog
            open={confirmPopup}
            maxWidth="md"
            fullScreen={false}
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: '500px',
                    width: '100%',
                    borderRadius: '16px',
                },
            }}
        >
            <div className={`w-full max-w-lg ${themeStyles.main.tailwindMainBg} p-5`}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320.591 320.591"
                    className={`w-3 cursor-pointer float-right ${closeIconFill}`}
                    onClick={closeModal}
                >
                    <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                    <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                </svg>

                <div className="my-8 text-center">
                    <h4 className={`text-base font-semibold mt-4 ${themeStyles.main.textHeadingColor}`}>
                        {data?.title}
                    </h4>

                    <h6 className={`text-base font-semibold mt-2 ${themeStyles.main.textHeadingColor}`}>
                        {data?.summary}
                    </h6>
                </div>

                <div className="text-center flex justify-center gap-4">
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: colorConfigs.btn.cancel.bg,
                            border: colorConfigs.btn.cancel.border,
                            color: colorConfigs.btn.cancel.color
                        }}
                        onClick={closeModal}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        sx={{ backgroundColor: colorConfigs.btn.main.bg }}
                        onClick={confirmModal}
                    >
                        {data?.confirmBtn ? data?.confirmBtn : "Yes"}
                    </Button>
                </div>
            </div>
        </Dialog>
    )
}

export default ConfirmPopup;
